import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks";

export function AnonymousRouteWrapper() {
  const { user } = useAuth();
  return user ? <Navigate to="/dashboard" replace /> : <Outlet />;
}
